(function () {
    'use strict';

    angular.module("imApp").factory("orderPurchMenuService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 999,
                    parameters: parms || {}
                });
            },
            listPurchaseHeads: function (parms) {
                return $ihttp.post({
                    method: 1000,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
